import { useTranslate } from 'react-admin'

import { AIS_DIFFERENCE_COLORS, AIS_DIFFERENCE_INTERVALS, type AisDifferenceLevel, signedDuration } from '@/domain/aisDifference'

const NOT_COMPARED_COLOR = '#6B7280'

const [GREEN_UP_TO_S = 0, AMBER_UP_TO_S = 0] = AIS_DIFFERENCE_INTERVALS.map(({ upToS }) => upToS)

export const aisDifferenceColor = (level: AisDifferenceLevel | null): string =>
  level === null ? NOT_COMPARED_COLOR : AIS_DIFFERENCE_COLORS[level]

export const useAisDifference = () => {
  const translate = useTranslate()
  const meaning: Record<AisDifferenceLevel, () => string> = {
    GREEN: () => translate('pages.scales.timeline.ais.level.GREEN', { max: GREEN_UP_TO_S / 60 }),
    AMBER: () => translate('pages.scales.timeline.ais.level.AMBER', { max: AMBER_UP_TO_S / 60 }),
    RED: () => translate('pages.scales.timeline.ais.level.RED', { min: AMBER_UP_TO_S / 60 }),
  }
  return {
    signed: (differenceS: number): string => translate('pages.scales.timeline.ais.duration', signedDuration(differenceS)),
    meaning: (level: AisDifferenceLevel): string => meaning[level](),
  }
}
